const loyaltyConstants = {
	vipTiers: {
		currentStatusLabel: "current status",
		benefitHeaders: [
			"Welcome Offer",
			"Shipping",
			"Birthday Bonus",
			"VIP access to offers, promotions and new product launches.",
			"Priority customer support",
            "Invitations to the testing taskforce"
		],
		tierSpend: "Points Per Calendar Year",
		benefitsList: [
			{
				tierId: 15401,
				tierRequirement: "$0 to $149 spend",
				benefits: [
					"15% Off Your First Order",
					"Free Shipping over $55",
					"",
					"",
                    "",
					""
				]
			},

				{
				tierId: 15402,
				tierRequirement: "$150 to $349 spend",
				benefits: [
					"Mini merch or mini Screen",
					"Free Shipping over $55",
					" ",	
					"☀",
                    "",
					""
				]
			},

				{
				tierId: 15403,
				tierRequirement: "$350 to $549 spend",
				benefits: [
					"Midi merch or Sheen Screen",
					"Free Standard Shipping on all orders",
					"$20 birthday reward",
                    "☀",
					"☀",
					"☀"
				]
			},

          	{
				tierId: 15404,
				tierRequirement: "$550+ spend",
				benefits: [
					"Major merch or full sized Screen",
					"Free Express Shipping on All orders",
					"$30 birthday reward",
                    "☀",
					"☀",
					"☀"
				]
			}
		]

	}
}